import React, { Dispatch } from "react";
import {
  Box,
  Checkbox,
  FormControlLabel,
  Stack,
  Typography,
} from "@mui/material";

import { Organization } from "../../hooks/confg/base";

type PartNumberCheckboxProps = {
  disabled: boolean;
  partNumber: Organization["partNumber"];
  setPartNumber: Dispatch<React.SetStateAction<Organization["partNumber"]>>;
};

const PartNumberCheckboxes = (props: PartNumberCheckboxProps) => {
  const { disabled, partNumber, setPartNumber } = props;

  const handleUnique = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPartNumber({
      unique: event.target.checked,
      required: partNumber.required,
    });
  };

  const handleRequired = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPartNumber({
      unique: partNumber.unique,
      required: event.target.checked,
    });
  };

  return (
    <Stack direction={"row"} spacing={2} alignItems={"center"}>
      <Typography>Part number:</Typography>

      <Box sx={{ display: "flex", flexDirection: "row" }}>
        <FormControlLabel
          label="unique"
          disabled={disabled}
          control={
            <Checkbox checked={partNumber.unique} onChange={handleUnique} />
          }
        />

        <FormControlLabel
          label="required"
          disabled={disabled}
          control={
            <Checkbox checked={partNumber.required} onChange={handleRequired} />
          }
        />
      </Box>
    </Stack>
  );
};

export default PartNumberCheckboxes;
